//http://localhost:3000/brokerPoliticas/d87760f9d6fd024ab4e1c9ddb97b93ed
//http://iospage.iosoffices.com/portal/getBrokerPoliticasData
//http://localhost:8888/Api2/src/public/portal/getBrokerPoliticasData
import React, { Component } from 'react';
import * as $ from 'jquery';
import PoliticasHeader from '../PoliticasHeader.js';
import PoliticasFooter from '../PoliticasFooter.js';
import BrokerFormularioAceptar from './BrokerFormularioAceptar.js';
import PoliticasFirmadasGracias from './PoliticasFirmadasGracias.js';
import axios from 'axios'; //llamar WS
import brandLogo from '../../images/brand-logo-dark.png';
import { Redirect, withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import { translate } from 'react-i18next'; //esp/eng

let cancelToken;

class BrokerPoliticasContainer extends Component {

  constructor(props) {
    super(props);
    this.state = this.getInitState(); 
  }

  componentWillMount() {
    cancelToken = axios.CancelToken.source();
    broker_asesor_id: this.props.match.params.broker_asesor_id;

  }

  componentDidMount() {
    this.getBrokerPoliticasData({
      token_id: this.props.getTokenId(),
      token_session: this.props.getTokenSession(),
      broker_asesor_id: this.props.match.params.broker_asesor_id
    });
  }  

  reload = () => {
    this.getBrokerPoliticasData({
      token_id: this.props.getTokenId(),
      token_session: this.props.getTokenSession(),
      broker_asesor_id: this.props.match.params.broker_asesor_id
    });
  }

  renderPoliticasHeader = () => {
    return(<PoliticasHeader />);
  }

  renderPoliticasFooter = () => {
    return(<PoliticasFooter />);
  }

  renderBrokerFormularioAceptar = () => {
    return(
      <BrokerFormularioAceptar
      handleQuestionsForm={this.handleQuestionsForm}
      activarBoton={this.activarBoton}
      asesor={this.state.asesor}
      />
     
    );
  }

  renderPoliticasFirmadasGracias = () => {
    return(<PoliticasFirmadasGracias
        asesor={this.state.asesor}
      />);
  }
 
  getInitState = () => {
    return({
      asesor: null
    });
  }

  getBrokerPoliticasData = (params) => {
    //console.log("params------>",params);
    this.props.post(
      "/getBrokerPoliticasData",
      params,
      (response) => this.didGetBrokerPoliticasData(response),
      (error) => this.props.handleErrorResponse(error),
      cancelToken
    );
  }

  didGetBrokerPoliticasData = (response) => {
    console.log(response);
    this.setState({
      asesor: response
    }, this.scrollTop);
  }

/* ----- enviar formulario ---- */
 handleQuestionsForm = (event) => {
  //console.log("enviando a firmarPoliticas------>",this.props);
    event.preventDefault();
    this.firmarPoliticas({
      broker_asesor_id: this.state.asesor.token,
      token_id: this.props.getTokenId(),
      token_session: this.props.getTokenSession()
    }); 
  }
  firmarPoliticas = (params) => {
    //console.log("params------>",params);
    this.props.post(
      "/firmarPoliticas",
      params,
      (response) => this.didFirmarPoliticas(response),
      (error) => this.props.handleErrorResponse(error),
      cancelToken
    );
  }

  didFirmarPoliticas = () => {
    //mostrar agradecimiento por firmar las politicas broker
    $('#formularioFirmarPoliticas').addClass('hidden');
    $('#politicasFirmadas').removeClass('hidden'); 
  }  
/* ----- enviar formulario ----- */
  render() {
    return(
      <div>
        {this.renderPoliticasHeader()}
          <div className="container-fluid" > 
            {this.renderBrokerFormularioAceptar()}
          </div>
        {this.renderPoliticasFirmadasGracias()}
        {this.renderPoliticasFooter()}
      </div>
    );
  }
}

export default compose(
  translate('common'),
  withRouter
)(BrokerPoliticasContainer);


// WEBPACK FOOTER //
// ./src/guest/BrokerPoliticas/BrokerPoliticasContainer.js